import { useContext } from 'react';

import { ModalWrapperContext } from './ModalWrapperContext';

export const useModalWrapperContext = () => {
  const context = useContext(ModalWrapperContext);

  if (!context)
    throw new Error(
      'useModalWrapperContext needs to be used within ModalWrapperContext.Provider!'
    );

  return context;
};
